import * as React from "react";
import { forwardRef } from "react";
const SvgMessageDeliveryStatusPending = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, viewBox: "0 0 10 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 4a5 5 0 1 0 5 5 5.006 5.006 0 0 0-5-5m0 .833A4.167 4.167 0 1 1 4.833 9 4.16 4.16 0 0 1 9 4.833m-.417.833v3.75H11.5v-.833H9.417V5.667z", "data-name": "icon/time", transform: "translate(-4 -4)", fill: "#727d8e" }));
const ForwardRef = forwardRef(SvgMessageDeliveryStatusPending);
export { ForwardRef as ReactComponent };
